import React from "react";
import { UtensilsCrossed, Star, MapPin } from "lucide-react";

function scrollTo(id) {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
}

export default function MobileStickyNav() {
  const items = [
    { id: "menu", label: "MENU", Icon: UtensilsCrossed },
    { id: "club", label: "CLUB", Icon: Star },
    { id: "location", label: "DOVE SIAMO", Icon: MapPin },
  ];
  return (
    <nav
      className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0C0C0C]/95 backdrop-blur border-t border-[#242424] grid grid-cols-3"
      data-testid="mobile-sticky-nav"
    >
      {items.map(({ id, label, Icon }) => (
        <button
          key={id}
          onClick={() => scrollTo(id)}
          className="flex flex-col items-center gap-1 py-2.5 text-white active:text-[#FFC20E]"
          data-testid={`mobile-sticky-${id}`}
        >
          <Icon size={20} className="text-[#FFC20E]" />
          <span className="font-display font-bold uppercase text-[11px] tracking-wide">{label}</span>
        </button>
      ))}
    </nav>
  );
}
